import { Directive, HostListener } from "@angular/core";

@Directive({
	selector: "[phone-number-only]"
})
export class PhoneNumberOnlyDirective {

	private regex: RegExp = new RegExp(/^[0-9]$/g);
	private specialKeys: Array<string> = ['ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Tab', 'End', 'Home', '+'];

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent) {

		if (this.specialKeys.indexOf(event.key) !== -1) {

			return;
		}

		if (!String(event.key).match(this.regex)) {

			event.preventDefault();
		}
	}

	@HostListener('paste', ['$event'])
	preventPaste(event: KeyboardEvent) {

		event.preventDefault();
	}
}